<template>
    <div>
        <h1 class="display-heading">Change Password</h1>

        <change-password></change-password>
    </div>
</template>

<script>
import changePassword from '@/components/change-password';
export default {
    'name': 'ChangePassword',
    'components': {
        changePassword
    }
};
</script>
